import type { TranslationKey } from '@disa/i18n';
import {
  ChartColumn,
  House,
  LayoutGrid,
  type LucideIcon,
  NotebookPen,
  Waypoints,
  Wrench,
} from 'lucide-react';

/** What the shell can be showing, in the order the dock lists them. */
export type ShellView = 'home' | 'library' | 'tools' | 'lineups' | 'tactics' | 'stats';

export interface DockSection {
  view: ShellView;
  labelPath: TranslationKey;
  /**
   * The dock states an entry as a glyph and its name in words on hover or focus, so the glyph is
   * the entry's only permanent mark and is chosen for what the screen holds rather than for what it
   * is called: a match collection, a path from a spot to a spot, a column chart.
   */
  icon: LucideIcon;
  /**
   * An entry that is honest about being unfinished is focusable and says so in its label — the
   * navigation shape exists before the screen does. Every entry has a screen now.
   */
  isSoon: boolean;
  /** A way-in-only identity colour. The review stage still reserves these hues for demo data. */
  tone: string;
}

export const DOCK_SECTIONS: readonly DockSection[] = [
  {
    view: 'home',
    labelPath: 'library.shell.home',
    icon: House,
    isSoon: false,
    tone: 'linear-gradient(160deg, #42adff, #1672df)',
  },
  {
    view: 'library',
    labelPath: 'library.shell.library',
    icon: LayoutGrid,
    isSoon: false,
    tone: 'linear-gradient(160deg, #8d7cf5, #5a48ca)',
  },
  {
    view: 'tools',
    labelPath: 'library.shell.tools',
    icon: Wrench,
    isSoon: false,
    tone: 'linear-gradient(160deg, #f2a443, #cc751a)',
  },
  {
    view: 'lineups',
    labelPath: 'library.shell.lineups',
    icon: Waypoints,
    isSoon: false,
    tone: 'linear-gradient(160deg, #5ac580, #218750)',
  },
  {
    view: 'tactics',
    labelPath: 'library.shell.tactics',
    icon: NotebookPen,
    isSoon: false,
    tone: 'linear-gradient(160deg, #ed7b99, #b43d63)',
  },
  {
    view: 'stats',
    labelPath: 'library.shell.stats',
    icon: ChartColumn,
    isSoon: false,
    tone: 'linear-gradient(160deg, #ae7feb, #7442b5)',
  },
];
